export default __webpack_public_path__ + "static/media/Andy Barr.457e0aa5.jpg";